var angular = require('angular');
require('@uirouter/angularjs');
require('angular-ui-bootstrap');
require('angular-ui-ace');
require('angular-loading-bar');
require('angular-loading-bar/build/loading-bar.css');
require('angular-animate');
require('angularjs-toaster');
require('angularjs-toaster/toaster.css');
require('ng-table');



var app = angular.module('amt_admin.layout', [
    'ui.router',
    'ui.bootstrap',
    'angular-loading-bar',
    'ui.ace',
    'toaster',
    'ngAnimate'
]);


require('./resources/current_user_api.js').default(app)
require('./resources/layout.js').default(app);

// config loading bar
app.config(['cfpLoadingBarProvider', function (cfpLoadingBarProvider) {
    cfpLoadingBarProvider.includeSpinner = false;
}]);

// config main
app.config(['$locationProvider', function ($locationProvider) {
    $locationProvider.html5Mode({enabled: true, requireBase: false});
}]);

export default app.name;




